/* eslint-disable no-param-reassign */
import { newMealFromImportedRecipe } from '../services/meals';
import {
  beginGenerateRecipeAIOperation,
  beginGenerateRecipeImageAIOperation,
  checkGenerateRecipeAIOperation,
  checkGenerateRecipeImageAIOperation,
} from '../operations/meal_operations';
import { JobStatus } from '../API';
import {
  aiGenerationJobFinished,
  aiGenerationJobStarted,
  aiJobImageAvailable,
  aiJobMealAvailable,
  jobOutputSelector,
} from '../features/ai_generation/ai_generation_slice';
import { awaitableTimeout } from '../services/process';

// export const addBulkRecipesAction = (ldjsonListStr, recipesBoardId, menuId) => {}

// export const boardAddedToMealBasketAction = (recipesBoardId) => {
//   return async (dispatch, getState) => {
//     const recipesBoard =
//       standaloneRecipesBoardByIdSelector(getState(), recipesBoardId) ||
//       sharedRecipesBoardByIDSelector(getState(), recipesBoardId);
//     const mealIDsToAdd = [];
//     recipesBoard.menus.forEach((menu) => {
//       (menu.mealIDs || []).forEach((mealId) => {
//         if (Object.keys(getState().mealboard.meals).includes(mealId)) {
//           mealIDsToAdd.push(mealId);
//         }
//       });
//       (menu.sharedMealIDs || []).forEach((sharedMealId) => {
//         if (
//           Object.keys(getState().mealboard.sharedMeals).includes(sharedMealId)
//         ) {
//           mealIDsToAdd.push(sharedMealId);
//         }
//       });
//     });
//     const newMealBasketItems = mealIDsToAdd.map((mealID) => ({
//       mealID,
//       parentID: recipesBoardId,
//     }));
//     trackEvents([
//       { name: 'Meals added to basket', args: { source: 'recipes' } },
//     ]);
//     dispatch(mealsAddedToMealBasket(newMealBasketItems));
//   };
// };

// export const menuCopiedToRecipesBoardAction = (
//   recipesBoardId,
//   menuId,
//   toRecipesBoardId,
// ) => {
//   const tracker = useTracker();

//   const {
//     data: userProfile,
//     error: userProfileError,
//     isLoading: isUserProfileLoading,
//   } = useGetUserProfileQuery();

//   const {
//     data: currentSpaceMembership,
//     error: spaceMembershipLoadError,
//     isLoading: spaceMembershipLoading,
//   } = /*{ data: null, error: null, isLoading: false };*/ useGetCurrentSpaceMembershipQuery();

//   const {
//     data: healthProSpace,
//     error: healthProSpaceError,
//     isLoading: isHealthProSpaceLoading,
//   } = useGetSpaceQuery();

//   return async (dispatch, getState) => {
//     const sourceRecipesBoard = standaloneRecipesBoardByIdSelector(
//       getState(),
//       recipesBoardId,
//     );
//     const destinationRecipesBoard = standaloneRecipesBoardByIdSelector(
//       getState(),
//       toRecipesBoardId,
//     );
//     if (!sourceRecipesBoard || !destinationRecipesBoard) {
//       return;
//     }
//     // const isRecipesBoardEmbeddedInProgramme =
//     //   destinationRecipesBoard?.embeddedInContainerType ===
//     //     ContainerType.PROGRAMME &&
//     //   !!destinationRecipesBoard?.embeddedInContainerID;
//     // const programmeId = destinationRecipesBoard.embeddedInContainerID;
//     try {
//       const currentHealthProGroup =
//         healthProSpace && healthProGroupForSpaceID(healthProSpace.id);
//       const sourceMenu = sourceRecipesBoard.menus.find((m) => m.id === menuId);
//       const { meals } = getState().mealboard;
//       const sourceMealIds = sourceMenu.mealIDs.filter((mealID) =>
//         Object.hasOwn(meals, mealID),
//       );
//       const addMealsPromises = sourceMealIds.map((mealID) => {
//         const mealWithoutId = cloneObject(meals[mealID]);
//         return addMealOperation(
//           destinationRecipesBoard.id,
//           mealWithoutId,
//           currentSpaceMembership?.id,
//           currentHealthProGroup,
//         );
//       });
//       dispatch(showModalSpinner());
//       const copiedMeals = await Promise.all(addMealsPromises);
//       const newMenuId = uuid();
//       // if (isRecipesBoardEmbeddedInProgramme) {
//       //   dispatch({
//       //     type: 'MENU_IMPORTED_INTO_PROGRAMME_EMBEDDED_RECIPES_BOARD',
//       //     programmeId,
//       //     menuId: newMenuId,
//       //     title: sourceMenu.title,
//       //     meals: copiedMeals,
//       //   });
//       // } else {
//       dispatch({
//         type: 'MENU_IMPORTED',
//         recipesBoardId: toRecipesBoardId,
//         menuId: newMenuId,
//         title: sourceMenu.title,
//         meals: copiedMeals,
//       });
//       // }
//       const eventMealsArgs = copiedMeals.map((meal) => ({
//         id: meal.id,
//         recipeTitle: meal.recipes[0]?.title,
//       }));
//       tracker(userProfile, [
//         {
//           name: 'Menu copied',
//           args: { meals: eventMealsArgs },
//         },
//       ]);
//     } finally {
//       dispatch(hideModalSpinner());
//       // if (isRecipesBoardEmbeddedInProgramme) {
// reportAccountActivitySignalOperation({
//         spaceID,
//         friendlyUsername,
//         lastActivityObjectType: ActivityObjectType.PROGRAMMES,
//         lastActivityObjectID: programmeId,
//       });
//       //   await dispatch(syncProgrammeAction(programmeId));
//       // } else {
// reportAccountActivitySignalOperation({
//         spaceID,
//         friendlyUsername,
//         lastActivityObjectType: ActivityObjectType.RECIPES,
//         lastActivityObjectID: recipesBoardId,
//       });
//       await dispatch(syncRecipesBoardAction(toRecipesBoardId));
//       // }
//     }
//   };
// };

// export const duplicateStandaloneRecipesBoardAction = (
//   recipesBoardId,
//   callback,
// ) => {}

// export const ensureCategoryGRCRecipesLoadedAction = () => {
//   return async (dispatch, getState) => {
//     const grcRecipeIDs = (
//       getState().mealboard.grcRecipeCategories || []
//     ).flatMap((c) => c.result.data.map((r) => r.grcRecipeID));
//     dispatch(ensureGRCRecipesLoadedAction(grcRecipeIDs));
//   };
// };

export const createRecipeAIAction = (
  recipesBoardID,
  menuID,
  aiPrompt,
  onAdd,
  addToTop,
) => {
  return async (dispatch, getState) => {
    const MAX_WAIT_MS = 180000;
    const POLL_INTERVAL_MS = 2000;
    const [recipeJobID, imageJobID] = await Promise.all([
      beginGenerateRecipeAIOperation(aiPrompt),
      beginGenerateRecipeImageAIOperation(aiPrompt, '1024x1024'),
    ]);
    console.log({ recipeJobID, imageJobID });
    if (!recipeJobID) {
      throw new Error('No recipe job ID returned');
    }
    if (!imageJobID) {
      throw new Error('No image job ID returned');
    }
    dispatch(
      aiGenerationJobStarted({
        aiPrompt,
        recipesBoardID,
        menuID,
        addToTop,
        recipeJobID,
        imageJobID,
      }),
    );
    let msWaitedSoFar = 0;
    while (msWaitedSoFar < MAX_WAIT_MS) {
      // eslint-disable-next-line no-await-in-loop
      await awaitableTimeout(POLL_INTERVAL_MS);
      msWaitedSoFar += POLL_INTERVAL_MS;
      // eslint-disable-next-line no-await-in-loop
      const [recipeJobResult, imageJobResult] = await Promise.all([
        checkGenerateRecipeAIOperation(recipeJobID),
        checkGenerateRecipeImageAIOperation(imageJobID),
      ]);
      console.log({ recipeJobResult, imageJobResult });
      if (
        recipeJobResult?.jobStatus === JobStatus.FAILED ||
        imageJobResult?.jobStatus === JobStatus.FAILED
      ) {
        dispatch(
          aiGenerationJobFinished({
            recipeJobID,
            imageJobID,
          }),
        );
        break;
      }
      if (recipeJobResult?.jobStatus === JobStatus.COMPLETED) {
        const newMeal = newMealFromImportedRecipe(recipeJobResult.recipe);
        dispatch(
          aiJobMealAvailable({
            recipeJobID,
            meal: newMeal,
          }),
        );
      }
      if (imageJobResult?.jobStatus === JobStatus.COMPLETED) {
        dispatch(
          aiJobImageAvailable({
            imageJobID,
            imageUrl: imageJobResult.imageUrl,
          }),
        );
      }
      const { meal: completedMeal, imageUrl: completedImageUrl } =
        jobOutputSelector(getState(), recipeJobID, imageJobID);
      if (completedMeal && completedImageUrl) {
        dispatch(
          aiGenerationJobFinished({
            recipeJobID,
            imageJobID,
          }),
        );
        const mealToInsert = {
          ...completedMeal,
          recipes: [
            {
              ...completedMeal.recipes[0],
              imageUrl: completedImageUrl,
            },
          ],
        };
        const newCardData = {
          id: 'temp',
          title: mealToInsert.recipes[0].title,
          description: mealToInsert.recipes[0].shortDescription || '',
          label: '',
          style: { _meal: mealToInsert, _add_to_top: addToTop },
        };
        console.log({ newCardData });
        onAdd(newCardData);
        break;
      }
      // Keep looping
    }
  };
};

// const isImportRecordNotFinished = (record) =>
//   [JobStatus.PENDING, JobStatus.IN_PROGRESS].includes(
//     record.moderateJobStatus,
//   ) ||
//   [JobStatus.PENDING, JobStatus.IN_PROGRESS].includes(
//     record.generateImageJobStatus,
//   );

// export const importMealsFromCSVAction = (
//   fileList,
//   toRecipesBoardId,
//   toMenuId,
// ) => {
// const {
//   data: healthProSpace,
//   error: healthProSpaceError,
//   isLoading: isHealthProSpaceLoading,
// } = useGetSpaceQuery();
//   if (!fileList.length) {
//     console.log('No files');
//     return undefined;
//   }
//   const blob = fileList[0];
//   return async (dispatch, getState) => {
//  const currentHealthProGroup =
//    healthProSpace && healthProGroupForSpaceID(healthProSpace.id);
//     let records;
//     try {
//       const csvText = await blob.text();
//       records = importRecipesFromCSV(csvText);
//     } catch (e) {
//       console.warn(e);
//       dispatch(
//         showGlobalSnackbar({
//           notificationText: 'Error reading the CSV file.',
//         }),
//       );
//       return;
//     }
//     if (records.length === 0) {
//       console.log('No recipes to import');
//       return;
//     }
//     const MAX_WAIT_MS = 360000;
//     const POLL_INTERVAL_MS = 4000;
//     records.forEach((record) => {
//       record.moderatePromise = beginModerateRecipeAIOperation(
//         record.recipe.ingredients.map((i) => i.fullText),
//         record.recipe.preparations.map((p) => p.fullText),
//       );
//       record.generateImagePromise = beginGenerateRecipeImageAIOperation(
//         record.recipe.title,
//         '1024x1024',
//       );
//     });
//     const jobStartPromises = records.flatMap((record) => [
//       record.moderatePromise,
//       record.generateImagePromise,
//     ]);
//     const jobIDs = await Promise.all(jobStartPromises);
//     records.forEach((record, index) => {
//       record.recipesBoardID = toRecipesBoardId;
//       record.menuID = toMenuId;
//       record.moderateJobID = jobIDs[index * 2];
//       record.generateImageJobID = jobIDs[index * 2 + 1];
//       record.moderateJobStatus = JobStatus.PENDING;
//       record.generateImageJobStatus = JobStatus.PENDING;
//     });
//     dispatch({
//       type: 'RECIPES_IMPORT_AI_MODERATION_STARTED',
//       records,
//     });
//     let msWaitedSoFar = 0;
//     while (msWaitedSoFar < MAX_WAIT_MS) {
//       // eslint-disable-next-line no-await-in-loop
//       await awaitableTimeout(POLL_INTERVAL_MS);
//       msWaitedSoFar += POLL_INTERVAL_MS;
//       const recordsNotFinished = records.filter(isImportRecordNotFinished);
//       if (recordsNotFinished.length === 0) {
//         break;
//       }
//       const checkPromises = recordsNotFinished.flatMap((record) => [
//         checkModerateRecipeAIOperation(record.moderateJobID),
//         checkGenerateRecipeImageAIOperation(record.generateImageJobID),
//       ]);
//       // eslint-disable-next-line no-await-in-loop
//       const checkResults = await Promise.all(checkPromises);
//       recordsNotFinished.forEach((recordNotFinished, index) => {
//         const checkModerateResult = checkResults[index * 2];
//         const checkImageResult = checkResults[index * 2 + 1];
//         if (checkModerateResult) {
//           recordNotFinished.moderateJobStatus = checkModerateResult.jobStatus;
//           recordNotFinished.moderatedIngredients =
//             checkModerateResult.moderatedIngredients;
//           recordNotFinished.moderatedPreparations =
//             checkModerateResult.moderatedPreparations;
//         }
//         if (checkImageResult) {
//           recordNotFinished.generateImageJobStatus = checkImageResult.jobStatus;
//           recordNotFinished.imageUrl = checkImageResult.imageUrl;
//         }
//       });
//       records.forEach((record) => {
//         const recordNotFinished = recordsNotFinished.find(
//           (r) => r.moderateJobID === record.moderateJobID,
//         );
//         record.moderateJobStatus = recordNotFinished.moderateJobStatus;
//         record.moderatedIngredients = recordNotFinished.moderatedIngredients;
//         record.moderatedPreparations = recordNotFinished.moderatedPreparations;
//         record.generateImageJobStatus =
//           recordNotFinished.generateImageJobStatus;
//         record.imageUrl = recordNotFinished.imageUrl;
//         if (!isImportRecordNotFinished(record)) {
//           dispatch({
//             type: 'RECIPE_IMPORT_AI_FINISHED',
//             record,
//           });
//           const newMeal = {
//             recipes: [
//               {
//                 ...record.recipe,
//                 imageUrl: record.imageUrl,
//                 ingredients: record.moderatedIngredients.map((mi) => ({
//                   id: uuid(),
//                   fullText: mi,
//                 })),
//                 preparations: record.moderatedPreparations.map((mp) => ({
//                   id: uuid(),
//                   fullText: mp,
//                 })),
//               },
//             ],
//           };
//           addMealOperation(
//             toRecipesBoardId,
//             newMeal,
//             null,
//             currentHealthProGroup,
//           ).then((insertedMeal) => {
//             dispatch({
//               type: 'NEW_MEAL_ADDED',
//               recipesBoardId: toRecipesBoardId,
//               laneId: toMenuId,
//               meal: insertedMeal,
//               position: null,
//             });
//           });
//         }
//       });
//     }
//   };
// };

// export const grcRecipeImportedIntoRecipesBoardAction = (
//   grcRecipeID,
//   toRecipesBoardId,
//   toMenuId,
// ) => {
//   return async (dispatch, getState) => {
//     const grcRecipe = getState().mealboard.grcRecipes[grcRecipeID];
//     const newMeal = newMealFromGrcRecipe(grcRecipe);
//     dispatch(
//       newMealAddedAction(toRecipesBoardId, toMenuId, newMeal, null, () => {}),
//     );
//   };
// };

// export const grcRecipeImportedIntoRecipesBoardAction = (
//   grcRecipeID,
//   toRecipesBoardId,
//   toMenuId,
// ) => {
//   return async (dispatch, getState) => {
//     const grcRecipe = getState().grcRecipes[grcRecipeID];
//     const newMeal = newMealFromGrcRecipe(grcRecipe);
//     dispatch(
//       newMealAddedAction(toRecipesBoardId, toMenuId, newMeal, null, () => {}),
//     );
//   };
// };
